import ItemCard from "./ItemCard";
import styles from "./ItemGrid.module.css";

// Renders a list of items as a self-flowing responsive grid.
// `renderCard` is overridable so other surfaces (recommendations,
// search results) can swap the card. `min` overrides the target
// minimum tile width when the default 220px doesn't fit a layout.
export default function ItemGrid({ items = [], renderCard, min }) {
  const style = min ? { "--min": typeof min === "number" ? `${min}px` : min } : undefined;
  return (
    <div className={styles.grid} style={style}>
      {items.map((it) => (
        <div key={it.id ?? it.sku} className={styles.cell}>
          {renderCard ? renderCard(it) : <ItemCard item={it} />}
        </div>
      ))}
    </div>
  );
}
